/* eslint unicorn/filename-case: 0 sonarjs/no-identical-functions: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';
import createClass from 'create-react-class';
import { DISPLAY1 } from './display1';
import { DISPLAY_SAM } from './display-sam';
import { DISPLAY_RESE } from './display-rese';
import { DISPLAY_VILLEALMASPECTACLE } from './display-ville-alma-spectacle';
import { DISPLAY_LESAIGLESTR } from './display-les-aigles-tr';
import { DISPLAY_BIERESDUMONDE } from './display-bieres-du-monde';
import { DISPLAY_DEFAULTCARTPREVIEW } from './display-default-cart-preview';
import { DISPLAY_LECALYPSO } from './display-le-calypso';
import { DISPLAY_ROR } from './display-ror';
import { DISPLAY_LVLUP } from './display-lvlup';
import { DisplaySam2024 } from './display-sam-2024';
import { DisplayGP3R } from './display-gp3r';

//Uses window.tsapp
//const moment = require("moment");
//const _ = require("lodash");
const tr = require('ts-translate-js').default.boundTR;
//const trN = tr;

export * from './display1';
export * from './display-sam';
export * from './display-rese';
export * from './display-ville-alma-spectacle';
export * from './display-les-aigles-tr';
export * from './display-bieres-du-monde';
export * from './display-default-cart-preview';
export * from './display-le-calypso';
export * from './display-ror';
export * from './display-lvlup';


export const CART_DISPLAY_BYNAME = {

    DISPLAY1: DISPLAY1,

    DISPLAY_RESE: DISPLAY_RESE,

    // Careful here: COMOTION / SAM Integration
    DISPLAY_SAM: DISPLAY_SAM,

    DISPLAY_SAM_2024: DisplaySam2024,

    // Careful here: ROR Integration
    DISPLAY_ROR: DISPLAY_ROR,

    DISPLAY_VILLEALMASPECTACLE: DISPLAY_VILLEALMASPECTACLE,

    DISPLAY_LECALYPSO: DISPLAY_LECALYPSO,

    DISPLAY_LESAIGLESTR: DISPLAY_LESAIGLESTR,
    
    DISPLAY_BIERESDUMONDE: DISPLAY_BIERESDUMONDE,

    DISPLAY_DEFAULTCARTPREVIEW: DISPLAY_DEFAULTCARTPREVIEW,

    DISPLAY_LVLUP: DISPLAY_LVLUP,
    
    DISPLAY_GP3R: DisplayGP3R,

};


